// Placeholders for the corporate landing hero (LoggedOutHomePlusTwo,
// LoggedOutLandingPremierLeague) while fixture data is loading, sized to roughly
// match what they stand in for (.hero-badge / the ticker row, CompetitionFilter's
// chips, MarketPredictedCard) so nothing jumps once real data lands.

export const TickerSkeleton = () => (
    <div className="d-flex gap-3 mb-3half px-2" aria-hidden="true">
        <span className="shimmer bg-dark-mode-700  flex-shrink-0" style={{ width: 150, height: 34.75 }} />
        <span className="shimmer bg-dark-mode-700 rounded-3 flex-grow-1" style={{ height: 34.75 }} />
    </div>
);

export const CompetitionFilterSkeleton = () => (
    <div className="d-flex column-gap-2" aria-hidden="true">
        {/* Same padding/text size as the pill tabs, so the height matches at every breakpoint */}
        {[136, 92, 156].map((width, i) => (
            <span key={i} className="shimmer bg-dark-mode-700 border border-dark-mode-700 rounded-4 px-3 py-md-25 py-2 small flex-shrink-0" style={{ width }}>&nbsp;</span>
        ))}
    </div>
);

// Mirrors MarketPredictedCard's layout (top row, two team rows, bottom row) so the
// hero grid doesn't jump when real cards replace these.
export const MarketPredictedCardSkeleton = () => (
    <div className="d-flex flex-column gap-2half w-100 p-3 rounded-4 h-100" style={{ background: 'rgba(255,255,255,0.08)' }} aria-hidden="true">
        <div className="d-flex align-items-center justify-content-between w-100 gap-2">
            <span className="shimmer bg-dark-mode-700 rounded-2" style={{ width: 110, height: 21 }} />
            <span className="shimmer bg-dark-mode-700 rounded-pill" style={{ width: 105, height: 23 }} />
        </div>
        <div className="d-flex flex-column gap-2half w-100">
            {[0, 1].map((i) => (
                <div key={i} className="d-flex align-items-center justify-content-between w-100 gap-2">
                    <div className="d-flex align-items-center gap-2">
                        <span className="shimmer bg-dark-mode-700 rounded-1 flex-shrink-0" style={{ width: 30, height: 26 }} />
                        <span className="shimmer bg-dark-mode-700 rounded-2" style={{ width: 90, height: 20 }} />
                    </div>
                    <span className="shimmer bg-dark-mode-700 rounded-2" style={{ width: 32, height: 20 }} />
                </div>
            ))}
        </div>
        <div className="d-flex align-items-center justify-content-between w-100 gap-2">
            <span className="shimmer bg-dark-mode-700 rounded-2" style={{ width: 100, height: 14 }} />
            <span className="shimmer bg-dark-mode-700 rounded-2" style={{ width: 90, height: 15 }} />
        </div>
    </div>
);

// Stands in for the league rows in CorporateHeader's mobile drawer while the fixture
// feed loads. Four rows rather than one, at roughly the real name widths, so the
// section reads as "a few leagues are coming" and the CTA below doesn't jump once
// they land. Renders <li>s, so it belongs inside the drawer's <ul>.
const NAV_LEAGUE_WIDTHS = [106, 48, 143, 145];

export const NavLeagueSkeleton = () => (
    <>
        {NAV_LEAGUE_WIDTHS.map((width, i) => (
            <li key={i} className="d-flex align-items-center justify-content-between px-3" style={{ height: 48 }} aria-hidden="true">
                <span className="shimmer bg-dark-mode-700 rounded-2" style={{ width, height: 17 }} />
                <span className="shimmer bg-dark-mode-700 rounded-pill flex-shrink-0" style={{ width: 46, height: 20 }} />
            </li>
        ))}
    </>
);
